import { createFileRoute, redirect } from "@tanstack/react-router";
import { ordersInfiniteQuery } from "@/api/queries/orders";
import { DashboardOrdersPage } from "@/pages/dashboard/OrdersPage";
import { TableSkeleton } from "@/pages/dashboard/table/DataTable";

const statuses = ["all", "completed", "pending", "refunded"] as const;

export const Route = createFileRoute("/dashboard/orders")({
  // Mock data, hidden for real stores until orders are real (docs/plans/marketplace-commerce.md M3, M7).
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
  validateSearch: (search) => ({
    status: (typeof search.status === "string" && statuses.includes(search.status as (typeof statuses)[number])
      ? search.status
      : "all") as (typeof statuses)[number],
    q: typeof search.q === "string" ? search.q : "",
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.prefetchInfiniteQuery(
    ordersInfiniteQuery({
      ...(deps.status !== "all" && { status: deps.status as "completed" | "pending" | "refunded" }),
      ...(deps.q.trim() && { q: deps.q.trim() }),
    }),
  ),
  pendingComponent: TableSkeleton,
  component: DashboardOrdersPage,
});
